// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160904/js/" + chunkId + "." + {"44":"fb229e2b","225":"3d6372b4","481":"a8dc80f8","486":"94836cf3","770":"100ffc41"}[chunkId] + ".0.5415098856430643.chunk.js";
};